import { render, staticRenderFns } from "./PickerTree copy.vue?vue&type=template&id=213fccbb&scoped=true"
import script from "./PickerTree copy.vue?vue&type=script&lang=js"
export * from "./PickerTree copy.vue?vue&type=script&lang=js"
import style0 from "./PickerTree copy.vue?vue&type=style&index=0&id=213fccbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213fccbb",
  null
  
)

export default component.exports